import React, { useState } from "react";
import { assignMedicalRep } from "../../Redux/Actions/ActionMedicalRep";
import people from "../../images/icon_sidebar/people.png";
import loc from "../../images/icons/location_icon.svg";
import medd from "../../images/icons/med.png";
import { CheckFont } from "../General/GeneralComponent/CheckLang";
import InnerLoader from "../General/InnerLoader";
import FilterAssign from "./FilterAssign";
import { VariableAssign } from "./VariableAssign";

function AssignComponent({
  langmiamed,
  translate,
  target_group,
  loadingTargetGroup,
  dispatch,
  medical_rep_id,
}) {
  const { state, setLoad, handleCheckboxChange, handleSelectAll, resetState } =
    VariableAssign();
  const [openFitler, setOpenFilter] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const assign = () => {
    dispatch(assignMedicalRep(medical_rep_id, state.checkedIds, setLoad, resetState));
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const filteredTargetGroup = target_group.filter(
    (tt) =>
      tt.name.toLowerCase().includes(searchQuery) ||
      (tt.address && tt.address.toLowerCase().includes(searchQuery)) ||
      (tt.medical_rep_name &&
        tt.medical_rep_name.toLowerCase().includes(searchQuery))
  );
  return (
    <>
      <div className="div_assign ">
        <h5 className={langmiamed == "ar" ? "textRight" : ""}>
          {translate("target_group")}
        </h5>
        <div className="action_assign">
          <span
            className={`btn_assign ${
              langmiamed == "ar" ? "margin_left_10" : "margin_right_10"
            }`}
            onClick={assign}
          >
            {state.Load ? "Loading ..." : `${translate("assign")}`}
          </span>
          <span className="btn_assign" onClick={() => setOpenFilter(true)}>
            {translate("filter")}
          </span>
        </div>
      </div>

      {/* Search Input */}
      <div className="searchBox">
        <input
          type="text"
          placeholder={translate("search")}
          value={searchQuery}
          onChange={handleSearchChange}
          className="view_creatable1"
        />
        <div className="divForSelectAll">
          <div class="checkbox-wrapper-26">
            <input
              onChange={(event) =>
                handleSelectAll(event, "checkedIds", "selectAll", target_group)
              }
              checked={state.selectAll}
              type="checkbox"
              id="_checkbox-26"
            />
            <label for="_checkbox-26">
              <div class="tick_mark"></div>
            </label>
          </div>
          <span>{translate("selectall")}</span>
        </div>
      </div>
      <div className="div_checkbox">
        {loadingTargetGroup == false ? (
          filteredTargetGroup.length > 0 ? (
            filteredTargetGroup.map((tt) => {
              const isChecked =
                state.selectAll || state.checkedIds.includes(tt.id);
              return (
                <div className="name_medRep" key={tt.id}>
                  <div class="checkbox-wrapper-26">
                    <input
                      value={tt.id}
                      onChange={(event) =>
                        handleCheckboxChange(event, "checkedIds")
                      }
                      checked={isChecked}
                      type="checkbox"
                      id={tt.id}
                    />
                    <label for={tt.id}>
                      <div class="tick_mark"></div>
                    </label>
                  </div>

                  <div className="colcol">
                    <div className="bothcol">
                      <img src={people} />
                      <span
                        style={{ fontFamily: CheckFont(tt.name) }}
                        className={
                          langmiamed == "ar"
                            ? "margin_right_10"
                            : "margin_left_20"
                        }
                      >
                        {tt.name}
                      </span>
                    </div>
                    {tt.address != null && (
                      <div className="bothcol">
                        <img src={loc} />
                        <span
                          style={{ fontFamily: CheckFont(tt.address) }}
                          className={
                            langmiamed == "ar"
                              ? "margin_right_10"
                              : "margin_left_20"
                          }
                        >
                          {tt.address}
                        </span>
                      </div>
                    )}
                    {tt.medical_rep_name != null && (
                      <div className="bothcol">
                        <img src={medd} />
                        <span
                          style={{ fontFamily: CheckFont(tt.medical_rep_name) }}
                          className={
                            langmiamed == "ar"
                              ? "margin_right_10"
                              : "margin_left_20"
                          }
                        >
                          {tt.medical_rep_name}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div>{translate("no_results_found")}</div>
          )
        ) : (
          <div className="loadSetting">
            <InnerLoader />
          </div>
        )}
      </div>

      {openFitler && (
        <FilterAssign t={translate} open={openFitler} setOpen={setOpenFilter} />
      )}
    </>
  );
}

export default AssignComponent;
